import React, { useEffect } from 'react';

import { Icon } from '../UI';

import { useMerlinLogoColor } from '../../hooks/useMerlinLogoColor';
import { ModalProps } from './types';
import InfoTooltip from '../InfoTooltip/Info-tooltip';

/**
 * In order to change the color and zIndex of the "Merlin" logo, MUST mount and
 * unmount this component.
 */
export const Modal: React.FC<ModalProps> = ({
  isClosable = true,
  isTransparent = false,
  className = '',
  padding = 'none',
  backdrop = 'transparent',
  customMerlinLogoColor = '#B7FF00',
  element,
  title = '',
  isFullScreenElement = false,
  isOpen = false,
  infoTooltip = '',
  handleMerlinLogo = false,
  children,
  nav,
  z = 60,
  height = 'fixed',
  onCloseClick,
}) => {
  const { setCustomColor, resetColor } = useMerlinLogoColor(
    customMerlinLogoColor
  );

  useEffect(() => {
    if (isOpen && handleMerlinLogo) {
      setCustomColor();

      return () => {
        resetColor();
      };
    }
  }, [isOpen]);

  return !isOpen ? (
    <></>
  ) : (
    <aside
      className={`
      justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none
        z-${z}
        ${backdrop === 'solid' ? 'bg-black' : 'bg-black-backdrop'}
      `}
    >
      <div
        className={`
          ${className}
          relative w-150
          flex
          flex-col
          ${
            isTransparent
              ? ''
              : 'bg-white dark:bg-grey-90 border dark:border-grey-80'
          }
          dark:text-white
          ${
            padding === 'none'
              ? 'p-0'
              : padding === 'base'
              ? 'p-2 lg:p-5'
              : padding === 'large'
              ? 'p-8 lg:p-16'
              : padding === 'huge'
              ? 'p-16 lg:p-32'
              : ''
          }
          ${height === 'fixed' ? 'h-150 ' : 'h-auto'}
          ${
            isFullScreenElement
              ? 'rounded-none w-full h-full mx-auto'
              : 'min-h-1/6 max-h-5/6 rounded-xl mx-4 lg:mx-auto'
          }
        `}
      >
        <header>
          {/* NAV */}
          {nav}
          {/* close */}
          {isClosable && onCloseClick && (
            <Icon
              svgName="close"
              className="absolute right-4 top-4 text-right cursor-pointer z-10 dark:text-black"
              onClick={onCloseClick}
            />
          )}

          {/* title */}
          {title && (
            <div className={'flex h-20 mx-auto justify-center items-center'}>
              <h1
                className={
                  'w-auto text-black text-lg font-semibold text-center dark:text-white'
                }
              >
                {title}
              </h1>
              {infoTooltip && (
                <InfoTooltip
                  placement="right"
                  content={infoTooltip}
                  isTooltipIconVisible
                  tooltipPopupClassname={'flex w-96'}
                  tooltipIconClassName={'ml-1'}
                />
              )}
            </div>
          )}
        </header>

        {/* children */}
        {element || children}
      </div>
    </aside>
  );
};
